import { FC } from 'react';
import styled from 'styled-components';
import {
    CommonModal,
    CommonModalContainer,
    CommonModalProps,
    CUSTOM_STYLES,
} from '../CommonModal';
import { CommonButton } from '../CommonButton';

export type MessageModalProps = CommonModalProps & {
    message: string;
    showButton?: boolean;
    buttonText?: string;
    onButtonClick?: () => void;
    hideCloseButton?: boolean;
};

const MessageModalContainer = styled(CommonModalContainer)`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    min-width: 38.75rem;
    min-height: 26.125rem;
`;

const MessageModalText = styled.div`
    font-family: Signika-Bold;
    font-size: 2.875rem;
    font-weight: bold;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.13;
    letter-spacing: normal;
    text-align: center;
    width: 26rem;
    color: ${({ theme }) => theme.color};
`;

const ButtonContainer = styled.div`
    margin-top: 2rem;
`;

export const MessageModal: FC<MessageModalProps> = ({
    message,
    showButton = false,
    buttonText,
    onButtonClick,
    hideCloseButton = false,
    ...props
}) => {
    return (
        <CommonModal
            {...props}
            hideCloseButton={hideCloseButton}
            style={{
                overlay: { ...CUSTOM_STYLES.overlay, zIndex: 1000 },
                content: { ...CUSTOM_STYLES.content },
            }}
            Container={MessageModalContainer}
            className="ReactModal__Content__Message--after-open-override"
        >
            <MessageModalText>{message}</MessageModalText>
            {showButton && buttonText && onButtonClick && (
                <ButtonContainer>
                    <CommonButton handleClick={onButtonClick}>
                        {buttonText}
                    </CommonButton>
                </ButtonContainer>
            )}
        </CommonModal>
    );
};
